export default function Reputation() {
  const testimonials = [
    {
      name: '小雨',
      role: '社区活跃用户',
      content: '在文爱社区找到了很多志同道合的朋友，每天最期待的就是打开社区看大家的分享。文字真的有神奇的力量！',
      avatar: 'https://readdy.ai/api/search-image?query=Soft%20watercolor%20portrait%20of%20a%20young%20Asian%20woman%20with%20warm%20smile%2C%20gentle%20expression%2C%20cream%20background%2C%20minimal%20artistic%20illustration&width=80&height=80&seq=testimonial-1&orientation=squarish',
    },
    {
      name: '星辰大海',
      role: '专栏作者',
      content: '作为一个热爱写作的人，文爱社区给了我一个展示自我的平台。这里的读者很真诚，评论都充满温度和思考。',
      avatar: 'https://readdy.ai/api/search-image?query=Watercolor%20portrait%20of%20a%20young%20Asian%20man%20with%20glasses%2C%20literary%20and%20thoughtful%20expression%2C%20cream%20background%2C%20minimal%20artistic%20illustration&width=80&height=80&seq=testimonial-2&orientation=squarish',
    },
    {
      name: '月光下的猫',
      role: '深夜电台主播',
      content: '深夜电台栏目让我找到了表达自我的方式。每当收到听众的留言说被我的文字治愈了，那种感觉真的无法形容。',
      avatar: 'https://readdy.ai/api/search-image?query=Gentle%20watercolor%20portrait%20of%20a%20young%20Asian%20woman%20in%20moonlight%2C%20soft%20and%20dreamy%20expression%2C%20cream%20background%2C%20minimal%20artistic%20illustration&width=80&height=80&seq=testimonial-3&orientation=squarish',
    },
  ];

  const stats = [
    { value: '50万+', label: '注册用户' },
    { value: '100万+', label: '原创文章' },
    { value: '500万+', label: '互动评论' },
    { value: '98%', label: '用户好评率' },
  ];

  return (
    <section className="mb-16" aria-labelledby="reputation-heading">
      <h2 id="reputation-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">
        社区口碑
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-10">
        {stats.map((stat, idx) => (
          <div
            key={idx}
            className="bg-accent-50 rounded-lg p-4 text-center"
          >
            <p className="text-xl md:text-2xl font-bold text-accent-600">{stat.value}</p>
            <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {testimonials.map((t, idx) => (
          <div
            key={idx}
            className="bg-background-100 rounded-lg p-5 md:p-6"
          >
            <div className="flex items-center gap-3 mb-4">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                <p className="text-xs text-foreground-400">{t.role}</p>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              &ldquo;{t.content}&rdquo;
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}